import { KisiStatus } from "@gymflow/types";
import { useContext } from "react";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../../../../hooks";
import { useClubSettings } from "../../../../../providers";
import { ToastContext } from "../../../../../providers/ToastProvider/context";
import { RouteFeature, RouteLayout } from "../../../../../routes";
import { Button, Spinner, Switch } from "../../../../atoms";
import { Settings04Icon } from "../../../../atoms/icons/Settings04Icon";
import { IntegrationCard } from "../../components/IntegrationCard";
import { kisiIntegrationRoutes } from "./KisiIntegration";

export const KisiIntegrationCardOld = () => {
  const { club } = useClubSettings();
  const toast = useContext(ToastContext);
  const history = useHistory();
  const { createClubLink } = usePortalRoutes();

  const isKisiProcessing = club?.kisiStatus
    ? (
        [
          "PROCESSING_ENABLE",
          "PROCESSING_DISABLE",
          "PROCESSING_MODIFY",
        ] as KisiStatus[]
      ).includes(club.kisiStatus)
    : false;
  return (
    <IntegrationCard
      logo={
        <div className="bg-kisi-logo size-10 rounded-lg bg-contain bg-center bg-no-repeat" />
      }
      title="Kisi"
      description="Mobile check ins and access control solution. Offer 24 hour access via the Gymflow mobile app."
      switchComponent={
        isKisiProcessing ? (
          <Spinner />
        ) : (
          <Switch
            value={club?.kisiStatus === "ENABLED"}
            onChange={() => {
              if (club?.kisiStatus === "ENABLED") {
                toast.toast({
                  message:
                    "This operation is not supported yet. If you want to disable Kisi please contact support.",
                  intent: "warning",
                });
              }
              if (club?.kisiStatus === "DISABLED") {
                history.push(
                  createClubLink(
                    RouteLayout.Staff,
                    RouteFeature.KisiIntegration,
                    kisiIntegrationRoutes.Enable,
                  ),
                );
              }
            }}
          />
        )
      }
      footer={
        <>
          {club?.kisiStatus === "ENABLED" && (
            <Button
              className="h-fit flex-row gap-1 p-0 text-sm hover:opacity-50"
              intent="link-secondary"
              link={createClubLink(
                RouteLayout.Staff,
                RouteFeature.KisiIntegration,
                kisiIntegrationRoutes.Edit,
              )}
            >
              <Settings04Icon />
              Update Integration
            </Button>
          )}
          {club?.kisiStatus === "DISABLED" && (
            <Button
              className="h-fit flex-row gap-1 p-0 text-sm hover:opacity-50"
              intent="link-secondary"
              link={createClubLink(
                RouteLayout.Staff,
                RouteFeature.KisiIntegration,
                kisiIntegrationRoutes.Enable,
              )}
            >
              <Settings04Icon />
              Enable Integration
            </Button>
          )}
          {isKisiProcessing && "Processing..."}
        </>
      }
    />
  );
};
